import { Bar, BarChart, CartesianGrid, LabelList, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"

interface iPropsStatusVolume {
    data: any[]
}
export default function BarChartStatusVolume({ data }:iPropsStatusVolume) {

    function handleData(dados: any[]):any[] {
        let registros:any[] = []
        let totalRegs = dados.length
        
        for (let reg of dados) {
            let statusCode = reg.statusCode

            let pesquisa = registros.filter(reg => reg.name === statusCode)
            let existe = pesquisa.length > 0 ? true : false

            if (!existe) {
                registros.push({
                    name: statusCode,
                    value: 1,
                    porcentagem: `${((1 * 100) / totalRegs).toFixed(2)}%`,
                })
            }

            if (existe) {
                let index = registros.indexOf(pesquisa[0])
                if (index < 0) {
                    continue
                }

                registros[index].value = registros[index].value + 1
                registros[index].porcentagem = `${((registros[index].value * 100) / totalRegs).toFixed(2)}%`
            }
        }
        console.log(registros)

        registros.sort(function(a, b){return b.value-a.value});

        return registros
    }

    const renderCustomizedLabel = (props:any) => {
        const { x, y, width, value } = props;
        const radius = 10;
      
        return (
          <g>
            <text x={x + width / 2} y={y - radius} fill="#000" textAnchor="middle" dominantBaseline="middle">
              {value}
            </text>
          </g>
        );
    };

    return (
        <div id="graph_status" className="graph_backgrounds">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                width={500}
                height={300}
                data={handleData(data)}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis dataKey="value" />
                    <Tooltip />
                    {/* <Legend /> */}
                    <Bar dataKey="value" fill="#128FE2" activeBar={<Rectangle fill="gold" stroke="purple" />} label={{fill: "black"}}>
                    {/* <Bar dataKey="value" fill={COLORS_GRAPH[index % COLORS_GRAPH.length]} activeBar={<Rectangle fill="gold" stroke="purple" />} label={{fill: "black"}}> */}
                        {/* {handleData(data).map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS_GRAPH[index % 20]} />
                        ))} */}
                        <LabelList dataKey="porcentagem" content={renderCustomizedLabel} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )

}